webpackJsonp([213720915766396],{

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Projects (props) {
	    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#58595B","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10"},[React.createElement("path",{"d":"M12.5 3.5l-4 4 7 7v3.992L22 17l1.5-7.5-4.5.5z","key":0}),React.createElement("path",{"d":"M13.25 12.25L4.5 21v2.5h-4v-3.991l6.635-5.189L10.5 9.5M14.5 5.5L16 4l3 3-1.5 1.5M15.5 16.23l4.607-1.425.787-5.015","key":1})]));
	}
	
	Projects.displayName = "Projects";
	
	Projects.defaultProps = {"viewBox":"0 0 24 24"};
	
	module.exports = Projects;
	
	Projects.default = Projects;


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SectionList = __webpack_require__(17);
	
	var _SectionList2 = _interopRequireDefault(_SectionList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionItemTitle = function SectionItemTitle(_ref) {
	  var children = _ref.children,
	      link = _ref.link;
	  return _react2.default.createElement(
	    _SectionList2.default.Title,
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: link },
	      children
	    )
	  );
	};
	
	exports.default = SectionItemTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  list-style: none;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n'], ['\n  list-style: none;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-bottom: ', ';\n  ', ';\n'], ['\n  margin-bottom: ', ';\n  ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    width: calc((100% - 80px)/2);\n    &:nth-child(2n) {\n      margin-left: 80px;\n    }\n  '], ['\n    width: calc((100% - 80px)/2);\n    &:nth-child(2n) {\n      margin-left: 80px;\n    }\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin-bottom: ', ';\n'], ['\n  margin-bottom: ', ';\n']);
	
	var _theme = __webpack_require__(14);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SectionList = _styledComponents2.default.ul(_templateObject);
	
	SectionList.Item = _styledComponents2.default.li(_templateObject2, function (props) {
	  return props.theme.l;
	}, (0, _theme.large)(_templateObject3));
	
	SectionList.Title = _styledComponents2.default.h3(_templateObject4, function (props) {
	  return props.theme.m;
	});
	
	exports.default = SectionList;
	module.exports = exports['default'];

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

	module.exports = [{"id":1,"title":"Volumetric rendering","link":"https://github.com/palasjir/ct-volumetric-rendering","description":"Sample application for real time volume rendering of image slices."},{"id":2,"title":"This blog","link":"https://github.com/palasjir/blog","description":"This blog, and everything I've used to create it with."}]

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(91);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageSection = __webpack_require__(36);
	
	var _PageSection2 = _interopRequireDefault(_PageSection);
	
	var _SitePage = __webpack_require__(39);
	
	var _SitePage2 = _interopRequireDefault(_SitePage);
	
	var _utils = __webpack_require__(40);
	
	var _PageSectionTitle = __webpack_require__(94);
	
	var _PageSectionTitle2 = _interopRequireDefault(_PageSectionTitle);
	
	var _projects = __webpack_require__(387);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _SectionList = __webpack_require__(17);
	
	var _SectionList2 = _interopRequireDefault(_SectionList);
	
	var _projects3 = __webpack_require__(368);
	
	var _projects4 = _interopRequireDefault(_projects3);
	
	var _SectionItemTitle = __webpack_require__(38);
	
	var _SectionItemTitle2 = _interopRequireDefault(_SectionItemTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageTitle = 'Projects';
	
	var ProjectsList = function ProjectsList(_ref) {
	  var projects = _ref.projects;
	  return projects ? _react2.default.createElement(
	    _SectionList2.default,
	    null,
	    projects.map(function (project) {
	      return _react2.default.createElement(ProjectsListItem, { key: project.id, project: project });
	    })
	  ) : null;
	};
	
	var ProjectsListItem = function ProjectsListItem(_ref2) {
	  var project = _ref2.project;
	  return _react2.default.createElement(
	    _SectionList2.default.Item,
	    null,
	    _react2.default.createElement(
	      _SectionItemTitle2.default,
	      { link: project.link },
	      project.title
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      project.description
	    )
	  );
	};
	
	var ProjectsPage = function ProjectsPage() {
	  return _react2.default.createElement(
	    _SitePage2.default,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: (0, _utils.createTitle)(pageTitle) }),
	    _react2.default.createElement(
	      _PageSection2.default,
	      { icon: _react2.default.createElement(_projects2.default, null) },
	      _react2.default.createElement(
	        _PageSectionTitle2.default,
	        null,
	        'Side projects'
	      ),
	      _react2.default.createElement(ProjectsList, { projects: _projects4.default })
	    )
	  );
	};
	
	exports.default = ProjectsPage;
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.createTitle = createTitle;
	function createTitle(title) {
	  return title + " | Jiri Palas";
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-ad0919d493fd638ee059.js